export { default } from './CorePublisherHeader';
